export const QUERY_KEY_PLANS = 'plans';
export const QUERY_KEY_CURRENT_USER = 'users/me';
export const QUERY_KEY_REVIEW_QUESTIONS = 'reviews/questions';
export const QUERY_KEY_RESTAURANT = 'restaurant';
export const QUERY_KEY_RESTAURANTS = 'restaurants';
export const QUERY_KEY_TAGS = 'tags';
export const QUERY_KEY_OFFICES = 'offices';
